import PropTypes from 'prop-types'
import { useEffect, useRef } from 'react'
import Slider from 'react-slick'
import './slick/slick.css'
import './slick/slick-theme.css'

const CarouselBig = ({ adjuntos, initialSlide = 0 }) => {
  const refSliderBig = useRef()

  useEffect(() => {
    if (refSliderBig.current) {
      refSliderBig.current.slickGoTo(initialSlide)
    }
  }, [initialSlide, adjuntos])

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide,
    centerMode: true,
    centerPadding: '0px'
  }

  return (
    <div className="carousel-big">
      <Slider {...settings} ref={refSliderBig}>
        {adjuntos.map((adjunto, index) => (
          <div key={index}>
            <p>
              <img src={adjunto} alt={''} />
            </p>
          </div>
        ))}
      </Slider>
    </div>
  )
}

CarouselBig.propTypes = {
  adjuntos: PropTypes.arrayOf(PropTypes.string).isRequired,
  initialSlide: PropTypes.number
}

export default CarouselBig
